"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.transformOrder = exports.transformRecommendations = exports.transformDeliveryServices = void 0;

var _collection = require("lodash/collection");

var _object = require("lodash/object");

var _array = require("lodash/array");

var _lang = require("lodash/lang");

var slotsMutator = function slotsMutator(timeline) {
  return timeline.map(function (_ref) {
    var attributes = _ref.attributes;
    var day = attributes.day,
        slots = attributes.slots;
    return {
      day: day,
      isDisabled: slots.length === 0 || (0, _collection.every)(slots, function (slot) {
        return slot.is_full;
      }),
      timeSlots: (0, _collection.map)(slots, function (slot) {
        return {
          end: slot.time_end,
          id: slot.id,
          isFull: slot.is_full,
          start: slot.time_start
        };
      })
    };
  });
};

var transformProductImage = function transformProductImage(media, size) {
  var image = (0, _array.head)(media);
  return "".concat(image.path, "/").concat(image.file, "_").concat(size, ".").concat(image.ext);
};

var transformDeliveryServices = function transformDeliveryServices(payload) {
  var data = (0, _object.get)(payload, 'data', []);
  /* We're sorting the deliveryServices by the slotType since we want the day_range
    delivery service to be the first one selected by default. Ideally the order should
    come defined by the API.
  */

  return (0, _collection.sortBy)(data.map(function (service) {
    return {
      firstAvailableSlot: (0, _collection.find)(slotsMutator(service.attributes.timeline), ['isDisabled', false]),
      isElegibleForSlotsSelection: service.attributes.slot_selection_enabled,
      name: service.attributes.service_name,
      price: Number.parseFloat(service.attributes.shipping).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      slots: slotsMutator(service.attributes.timeline),
      id: service.id,
      slotType: service.attributes.slot_type
    };
  }), function (deliveryService) {
    return deliveryService.slotType === 'day_range' ? 0 : 1;
  });
};

exports.transformDeliveryServices = transformDeliveryServices;

var transformRecommendations = function transformRecommendations(recommendations) {
  return (0, _array.slice)(recommendations, 0, 6).map(function (recommendation) {
    return {
      id: recommendation.id,
      name: recommendation.attributes.name,
      price: recommendation.attributes.price,
      image: transformProductImage(recommendation.attributes.medias.image, 'xl')
    };
  });
};

exports.transformRecommendations = transformRecommendations;

var transformOrder = function transformOrder(_ref2) {
  var id = _ref2.id,
      attributes = _ref2.attributes;
  return {
    address: attributes.address,
    deliveryDate: attributes.delivery_date,
    deliveryEnd: attributes.delivery_time_end,
    deliveryStart: attributes.delivery_time_start,
    id: (0, _lang.toString)(id),
    products: attributes.products.map(function (product) {
      return {
        quantity: product.quantity,
        price: Number.parseFloat(product.price).toLocaleString('es-ES', {
          style: 'currency',
          currency: 'EUR'
        }),
        sku: product.ean13,
        id: product.product_id,
        name: product.name,
        image: {
          large: transformProductImage(product.medias.image, 'large'),
          xl: transformProductImage(product.medias.image, 'xl')
        }
      };
    }),
    total: Number.parseFloat(attributes.total).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR'
    }),
    totalShipping: Number.parseFloat(attributes.total_shipment).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR'
    })
  };
};

exports.transformOrder = transformOrder;
var _default = {
  delivery: {
    services: []
  },
  payment: {
    creditCards: []
  },
  thanks: {
    id: '',
    address: '',
    deliveryDate: '',
    deliveryEnd: '',
    deliveryStart: '',
    products: [],
    total: ''
  },
  recommendations: []
};
exports.default = _default;